(() => {
  'use strict';
// ======== video auto play ========
const v = document.getElementById('v');
const tryPlay = () => {
  if (!v) return;
  // iOS対策：属性も必須（HTML側で <video id="v" muted playsinline> 推奨）
  v.muted = true;
  v.play().catch(() => {});
};
document.addEventListener('DOMContentLoaded', tryPlay, { once: true });
document.addEventListener('touchstart', tryPlay, { once: true }); // iOS保険
document.addEventListener('visibilitychange', () => { if (!document.hidden) tryPlay(); });


/* ======== galleryセクション・オーバーレイ ======================= */
(() => {
  const overlay = document.querySelector('[data-gallery-overlay]');
  const openBtn = document.querySelector('[data-gallery-open]');
  const closeBtn = document.querySelector('[data-gallery-close]');
  if (!overlay || !openBtn || !closeBtn) return;

  const bg = overlay.querySelector('.lp-inori-gallery__overlay-bg');

  const open = () => {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-modal-open');
  };
  const close = () => {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-modal-open');
  };

  openBtn.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  bg && bg.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });
})();


// ======== intro・collage フェードアップ ==========================
document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.fadeUp-on-scroll, .fadeUp-on-scroll--slow');
  if (!targets.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0 });

  targets.forEach(t => observer.observe(t));
});

// ===== lp-inori 共通モーダル：data-inori-* 版 =====
(() => {
  const overlay = document.querySelector('[data-inori-overlay]'); // 共通モーダル
  if (!overlay) return;

  // アイテム（任意のセクションで使い回し可）
  const itemsAll = [...document.querySelectorAll('[data-inori-item]')];
  if (itemsAll.length === 0) return;

  // モーダル内の要素
  const imgEl   = overlay.querySelector('[data-inori-modal-img]');
  const nameJa  = overlay.querySelector('[data-inori-modal-name-ja]');
  const nextBtn = overlay.querySelector('[data-inori-next]');
  const prevBtn = overlay.querySelector('[data-inori-prev]');
  const closeEls= overlay.querySelectorAll('[data-inori-close], .lp-inori__overlay-bg');

  const html = document.documentElement;
  const OPEN = 'is-open';

  // --- グループ分け（data-inori-group 未指定は default） ---
  const groups = {};
  itemsAll.forEach(el => {
    const g = el.getAttribute('data-inori-group') || 'default';
    (groups[g] ||= []).push(el);
  });

  // 現在位置
  const state = { group: 'default', index: 0 };

  const getGroupItems = (g) => groups[g] || [];

  const indexInGroup = (el, g) => getGroupItems(g).indexOf(el);

  const open = (group, index) => {
    const list = getGroupItems(group);
    if (!list.length) return;

    state.group = group;
    state.index = (index + list.length) % list.length;

    const li = list[state.index];

    // 優先：data-modal-src → <img data-modal-src|src>
    const directSrc = li.getAttribute('data-modal-src');
    const imgTag    = li.querySelector('img');
    const tagSrc    = imgTag ? (imgTag.getAttribute('data-modal-src') || imgTag.currentSrc || imgTag.src) : '';
    const src       = directSrc || tagSrc || '';

    const ja = li.getAttribute('data-name-ja') || li.getAttribute('aria-label') || '';

    if (imgEl) {
      imgEl.src = src;
      imgEl.alt = ja;
    }
    if (nameJa) nameJa.textContent = ja;

    overlay.classList.add(OPEN);
    overlay.setAttribute('aria-hidden', 'false');
    html.classList.add('is-modal-open');
  };

  const close = () => {
    overlay.classList.remove(OPEN);
    overlay.setAttribute('aria-hidden', 'true');
    html.classList.remove('is-modal-open');
  };

  const showNext = () => {
    const list = getGroupItems(state.group);
    if (!list.length) return;
    state.index = (state.index + 1) % list.length;
    open(state.group, state.index);
  };

  const showPrev = () => {
    const list = getGroupItems(state.group);
    if (!list.length) return;
    state.index = (state.index - 1 + list.length) % list.length;
    open(state.group, state.index);
  };

  // クリックで開く（自身の属するグループで連番化）
  itemsAll.forEach(el => {
    el.addEventListener('click', () => {
      const g = el.getAttribute('data-inori-group') || 'default';
      const i = indexInGroup(el, g);
      open(g, i);
    });
  });

  // 操作ボタン
  nextBtn && nextBtn.addEventListener('click', showNext);
  prevBtn && prevBtn.addEventListener('click', showPrev);
  closeEls.forEach(el => el.addEventListener('click', close));

  // キーボード操作
  document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains(OPEN)) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight') showNext();
    if (e.key === 'ArrowLeft') showPrev();
  });

  // 画像ロード時のフェード（ふんわり表示）
  if (imgEl) {
    imgEl.style.opacity = '0';
    imgEl.style.transition = 'opacity .35s ease';
    const fadeIn = () => (imgEl.style.opacity = '1');
    imgEl.addEventListener('load', fadeIn);
    // 初回オープン時用に一度発火しておく
    requestAnimationFrame(() => (imgEl.style.opacity = '1'));
  }
})();

(() => {
  const slider = document.querySelector('[data-craft-slider]');
  if (!slider) return;

  const track  = slider.querySelector('[data-craft-track]');
  const slides = Array.from(track.children);
  const dotsWrap = slider.querySelector('[data-craft-dots]');

  // 速度と間隔（CSSと一致）
  const SPEED = 1500;           // CSS: transition: transform 1500ms ease;
  const DURATION = 4200;        // 自動切替間隔

  // 念のためJS側でも遷移時間を指定（CSSのみでも可）
  track.style.transition = `transform ${SPEED}ms ease`;

  // ドット自動生成（既存の1個は破棄）
  dotsWrap.innerHTML = '';
  const dots = slides.map((_, i) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'lp-inori-craft__dot' + (i === 0 ? ' is-active' : '');
    b.setAttribute('aria-label', `${i+1}`);
    dotsWrap.appendChild(b);
    return b;
  });

  let index = 0;
  let timer = null;

  const go = (i) => {
    index = (i + slides.length) % slides.length;
    track.style.transform = `translateX(${-100 * index}%)`;
    dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
  };

  const next  = () => go(index + 1);
  const stop  = () => { if (timer) clearInterval(timer); timer = null; };
  const start = () => { stop(); timer = setInterval(next, DURATION); };

  // ドット操作
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      go(i);
      start(); // 手動後もオート継続
    });
  });

  // ホバー停止（PC向け）
  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);

  // タブ不可視で停止
  document.addEventListener('visibilitychange', () => {
    document.hidden ? stop() : start();
  });

  // ビューポート内のみ再生
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => e.isIntersecting ? start() : stop());
  }, { threshold: 0.2 });
  io.observe(slider);

  // 初期表示＆再生
  go(0);
  start();
})();

})();
